import * as actionTypes from "../actions/actionsTypes";

const initialState = {
  handicapRace2Data: {
    data: {
      labels: [],
      dataset: [],
      limitClampLegends: [],
      tabledata: []
    }
  },
};


export const handicapRace2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HANDICAP_RACE_DATA2:
      return {
        ...state,
        handicapRace2Data: action.payload,
      };
    default:
      return state;
  }
};
